import { useEffect, useState } from "react";
import { Concent } from "../components/concent"; // This component will also need useTranslation
import { Header } from "../components/headerTypeOne"; // This component will also need useTranslation
import { StickyActionContainer } from "../components/stickyByttonWithConcent"; // This component will also need useTranslation
import { TextBoxWithIcon } from "../components/textBoxWithIcon"; // This component will also need useTranslation
// import { Constants } from "../constants/textconstants"; // No longer needed for translatable strings
import { Style } from "../styles/otpverification";
import { useLocation } from "react-router-dom";
import { useTranslation } from '../i18n/useTranslation'; // Import the useTranslation hook

export const OTP = () => {
  const data = useLocation();
  const shop_name =
    data.state && data.state.retailer && data.state.retailer.shop_name;

  const [newPhoneNumber, setNewPhoneNumber] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [error, setError] = useState("");
  const isNew = data.state && data.state.newuser;
  const { t } = useTranslation(); // Initialize useTranslation

  useEffect(()=>{
    if(data.state && data.state.retailer && data.state.retailer.mobile_number){
      setPhoneNumber(data.state.retailer.mobile_number)
    }
  },[data.state]); // Added data.state to dependency array

  return (
    <div>
      <Header
        header={t('retailer_survey')} // Translate header
        subheader={t('otp_verification')} // Translate subheader
      />
      <div style={Style.container}>
        <span style={Style.infoText}>{t('send_sms')}</span> {/* Translate infoText */}
        <span style={Style.shopname}>{shop_name}</span>
        <TextBoxWithIcon
          iconname={"fa fa-phone"}
          handler={(e) => {
            const inputValue = e.replace(/\D/g, "");
            if (inputValue.length <= 10) {
              setNewPhoneNumber(inputValue);
              setPhoneNumber(inputValue) // Update phoneNumber as well for consistency
              setError("");
            } else {
              setError(t('please_enter_10_digits')); // Translate error message
            }
          }}
          placeHolder={newPhoneNumber === "" ? t('enter_10_digit_phone') : ""} 
          value={newPhoneNumber === "" ? phoneNumber : newPhoneNumber}
          isDisabled={false}
        />
        {error.length > 0 && <span style={Style.errormessage}>{error}</span>}
        <span style={Style.infoTexrtSub}>{t('otp_proceed')}</span> {/* Translate infoTexrtSub */}
      </div>
      <StickyActionContainer>
        <Concent
          phoneNumber={newPhoneNumber === "" ? phoneNumber : newPhoneNumber}
          isNewUser={true}
          retailer={data.state ? data.state.retailer : {}}
          oldPhone={data.state && data.state.retailer && data.state.retailer.mobile_number}
          creatingUser={isNew}
          userID = {data.state.parsedParameters? data.state.parsedParameters.user_id: ''}
          territoryID = {data.state.parsedParameters? data.state.parsedParameters.territory_id: ''}
        />
      </StickyActionContainer>
    </div>
  );
};